import { useEffect, useRef, useState } from "react";
import { DateTime } from "luxon";
import wsManager from "../../services/wsManager";
import IconSend from '../../components/icons/IconSend';
import IconCloseX from '../../components/icons/IconCloseX';
import axios from "axios";

// Always docked bottom-right, fixed to the viewport, above everything else
// (.floating-chat-container - see modals.css) - previously every caller
// passed its own `position` variant (left-chat-cont-position/
// left-middle-chat-cont-position/default), each `position:absolute`
// against whatever ancestor happened to establish one, so the popup landed
// in a different spot depending on which page opened it. One fixed
// position everywhere, no `position` prop needed anymore.
export default function ChatComponent({
          chatId, studentId, clientId,
          closeCallback, readedCallback}) {

  const [messages, setMessages] = useState([]);
  const [input, setInput] = useState("");
  const [name, setName] = useState("");
  const [surname, setSurname] = useState("");
  const [username, setUsername] = useState("");
  const [autorizedChatId, setAutorizedChatId] = useState();
  const messagesEndRef = useRef(null);
  const wsRef = useRef({ topic: null, handler: null });
  const isInited = useRef(false);
  const [closed , setClosed] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);

  useEffect(() => {

    if (chatId == -1 || studentId == -1 || clientId == -1) return;

    if (isInited.current) return;
    isInited.current = true;

    axios.get(`/api/chats/init?` +
      `chatId=${chatId ? chatId : ""}&` +
      `studentId=${studentId ? studentId : ""}&` +
      `clientId=${clientId ? clientId : ""}`, {
      withCredentials: true,
    }).then(res => {
      if (res.data.chatId) {
        setAutorizedChatId(res.data.chatId);
        setName(res.data.name);
        setSurname(res.data.surname);
        setUsername(res.data.username);
      }
    }).catch(err => {
      console.log(err);
    }).finally( () =>{
      setIsLoaded(true);
    })

  }, [studentId, clientId, chatId])

  useEffect(() => {

    if (!autorizedChatId) return;

    const topic = `/topic/chat/${autorizedChatId}`;

    const handler = (event) => {

      if (event.type === "history") {
        setMessages(event.payload);
        setChatReaded();
      }

      if (event.type === "message") {
        setMessages(prev => [...prev, event.payload]);
      }

    };

    wsManager.subscribe(topic, handler);
    wsRef.current = { topic, handler };
    return () => {
      wsManager.unsubscribe(topic, handler);
    };

  }, [autorizedChatId]);

  const setChatReaded = () => {
    let url = `/api/chats/read/${autorizedChatId}`
    axios.post(
      url,
      { },
      { withCredentials: true })
      .then(response => {
        if (readedCallback) {
          readedCallback(autorizedChatId);
        }
      })
  }

  const closeChat = () => {
      if (wsRef.current.topic && wsRef.current.handler) {
        wsManager.unsubscribe(wsRef.current.topic, wsRef.current.handler);
      }
      setMessages([]);
      setClosed(true);
      setAutorizedChatId(null);


      if (closeCallback) {
        closeCallback();
      }
  }

  const convertTime = (dateTime) => {
    if (!dateTime) return '';
    const cleaned = dateTime.replace(/\[.*\]/, "");
    const dt = DateTime.fromISO(cleaned).toLocal().toFormat("dd LLL HH:mm");
    return dt;
  }
  const sendMessage = () => {
    if (!input.trim()) return;

    const message = {
      chatId: autorizedChatId,
      message: input,
      isBot:1
    };
    wsManager.send("/app/chat", message);

    setInput("");
  };
  useEffect(() => {
    if (messagesEndRef.current) {
        messagesEndRef.current.scrollTop =
        messagesEndRef.current.scrollHeight;
    }
  }, [messages]);

  if (closed) return '';

  const initials = ((name || '?').charAt(0) + (surname || '').charAt(0)).toUpperCase();

  return (
    autorizedChatId ? (
    <div key={autorizedChatId} className="floating-chat-container">
      <div className="floating-chat-header">
        <div className="floating-chat-header-identity">
          <span className="floating-chat-avatar">{initials}</span>
          <div className="floating-chat-header-text">
            <p className="floating-chat-header-name">{name} {surname}</p>
            {username ? <p className="floating-chat-header-username">Telegram: @{username}</p> : ''}
          </div>
        </div>
        <span className="floating-chat-close-btn" onClick={closeChat} title="Закрити">
          <IconCloseX className='floating-chat-close-icon' />
        </span>
      </div>

      <div className="floating-chat-messages" ref={messagesEndRef}>
          {
            messages && Array.isArray(messages) && messages.length > 0 ? (
              messages.map(item => (
                item.isBot == 1 ?
                  <div key={item.id} className='floating-chat-row floating-chat-row-bot'>
                    <span className='floating-chat-avatar floating-chat-avatar-bot' title='Bot'>B</span>
                    <div className='floating-chat-bubble floating-chat-bubble-bot'>
                      <p className='floating-chat-bubble-text'>{item.text}</p>
                      <span className='floating-chat-bubble-time'>{convertTime(item.dateTime)}</span>
                    </div>
                  </div>
                  :
                  <div key={item.id} className='floating-chat-row floating-chat-row-user'>
                    <div className='floating-chat-bubble floating-chat-bubble-user'>
                      <p className='floating-chat-bubble-text'>{item.text ? item.text : item.message}</p>
                      <span className='floating-chat-bubble-time'>{convertTime(item.dateTime)}</span>
                    </div>
                    <span className='floating-chat-avatar floating-chat-avatar-user' title={name}>{initials}</span>
                  </div>
              ))
            ) : (<p className='floating-chat-empty-hint'>Ще немає повідомлень</p>)
          }
      </div>

      <div className="floating-chat-input-row">
        <input className="floating-chat-input"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            placeholder="Напишіть повідомлення..."
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sendMessage();
              }
            }}
          />
        <span className="floating-chat-send-btn" onClick={sendMessage}>
          <IconSend fillColor='icon-orange' style={{rotate:"-45deg"}} />
        </span>
      </div>

    </div>
    ) : isInited && isLoaded? (
      <div className="floating-chat-container floating-chat-empty-state">
        <span className="floating-chat-close-btn" onClick={closeChat} title="Закрити">
          <IconCloseX className='floating-chat-close-icon' />
        </span>
        <p>Цей клієнт/студент ще не привʼязаний до жодного зовнішнього месенджера</p>
      </div>
    ) : ''
  );
}
